export const SALES_OFFICE_EXPORT_ID = 'sales-office';

export const SALES_OFFICE_TITLE = 'Oficinas de Venta';

export const LOCALIZED_PROPERTIES = {
  externalKeys: 'Codigo',
  name: 'Nombre',
  officeGroup: 'Grupo de Oficina',
  company: 'Compañía',
  type: 'Tipo',
  divisions: 'División',
  channel: 'Canal',
  distributionchain: 'Cadena de Distribución',
  warehouses: 'Almacenes',
  status: 'Estado',
};
